import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription } from "rxjs";
import { ReleaseNote } from "src/app/model/release-note";
import { AppState } from "src/app/store/app.reducer";
import { selectReleaseNoteList, selectUser } from "src/app/store/user/user.selector";
import { StandardPageLayout } from "../../stdlayoutlib/classes.stdlayoutlib";
import { RELEASE_NOTES_VIEW, User } from "src/app/model/user";
import packageJson from 'package.json';
import * as UserActions from 'src/app/store/user/user.actions';

@Component({
	templateUrl: './release-note.dialog.component.html',
})
export class ReleaseNoteDialogComponent implements OnInit, OnDestroy {

	releaseNoteList?: ReleaseNote[];
	releaseNoteList$: Observable<ReleaseNote[]>;
	releaseNoteListSub?: Subscription;

	currentUser?: User;
	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	newVersion: boolean = false;
	newVersionError: boolean = false;
	enableBeta: boolean = false;
	sistemVersion: string;

	limitedList: boolean;
	activeIndex: number;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.releaseNoteList$ = this.store.select(selectReleaseNoteList);
		this.user$ = this.store.select(selectUser);
	}

	ngOnInit(): void {
		// we need to do a new dispatch GET api after home.component (or others main components) because we need to empty list
		this.store.dispatch(UserActions.getReleaseNoteList({ size: RELEASE_NOTES_VIEW })); 

		this.sistemVersion = packageJson.version;
		this.newVersion === false;

		this.releaseNoteListSub = this.releaseNoteList$
			.subscribe(releaseNoteList => {
				this.releaseNoteList = releaseNoteList;
				this.checkNewVersion();
				this.checkErrorNewVersion();
			}
			);
		this.userSub = this.user$?.subscribe(currentUser => {
			this.currentUser = currentUser;
			if (currentUser.JumpFe) {
				this.enableBeta = true;
			}
			this.checkNewVersion();
		});

		this.limitedList = true;
		this.activeIndex = 0;
	}

	closeDialog(): void {
		/*if (this.releaseNoteList !== undefined && this.releaseNoteList.length > 0) {
			this.store.dispatch(UserActions.setFeReleaseVersion({ version: this.releaseNoteList[0].ReleaseVersion }));
		}*/
		this.ref.close();
	}

	ngOnDestroy(): void {
		this.releaseNoteListSub?.unsubscribe();
		this.userSub?.unsubscribe();
	}

	checkNewVersion(): void {
		if (this.currentUser !== undefined && this.currentUser.Email !== undefined &&
			this.currentUser.Email !== '' && (this.currentUser.ReleaseVersion === '' ||
				(this.releaseNoteList !== undefined && this.releaseNoteList.length > 0 &&
					this.currentUser.ReleaseVersion !== this.releaseNoteList[0].ReleaseVersion))) {
			this.newVersion = true;
		} else {
			this.newVersion = false;
		}
	}

	checkErrorNewVersion(): void {
		if (this.releaseNoteList !== undefined && this.releaseNoteList.length > 0 &&
			this.sistemVersion !== this.releaseNoteList[0].ReleaseVersion && !this.sistemVersion.includes('rev')) {
			this.newVersionError = true;
		} else {
			this.newVersionError = false;
		}
	}

	expandAll() {
		this.store.dispatch(UserActions.getReleaseNoteList({}));
		this.limitedList = false;
		this.activeIndex = -1;
	}

	collapseAll() {
		this.releaseNoteList = this.releaseNoteList.slice(0,RELEASE_NOTES_VIEW);
		this.limitedList = true;
		this.activeIndex = 0;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}